import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/ScrollSection';

function InsuranceSelfPay() {
  return (
    <>
      {/* Hero Section */}
      <div
        className="container-fluid page-header wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          // background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/Insurance.jpeg)',
          backgroundColor: '#0066cc',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container text-center py-5 mt-4">
          <h1 className="display-2 text-white fw-bold mb-3 animated slideInDown" style={{ fontFamily: 'Georgia, serif' }}>
            Insurance & Self-Pay
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item fw-bold">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item fw-bold text-white" aria-current="page">
                Insurance & Self-Pay
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5" style={{ maxWidth: '1200px' }}>
        {/* Section 1: Insurance Verification & Registration Process */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Insurance Verification & Registration Process
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              At Tema General Hospital, the Records Unit (Health Information Unit) is responsible for patient registration, appointment booking, and insurance verification before a patient proceeds to see a doctor.
            </p>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              Step-by-Step Process
            </h3>

            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-1-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Arrival & Registration
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Patients report to the Records Unit / OPD Registration Desk upon arrival.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-2-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Insurance Presentation
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Patients must present a valid insurance card (NHIS or approved private insurance).
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-3-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Insurance Validity Check
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Records staff verify:
                  </p>
                  <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginTop: '0.5rem', marginBottom: 0 }}>
                    <li>Insurance validity and active status</li>
                    <li>Patient details</li>
                    <li>Eligibility for covered services</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    <i className="bi bi-4-circle-fill me-2" style={{ color: '#0066cc' }}></i>
                    Patient Booking
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Once insurance is confirmed (or payment option selected), the patient is registered and booked to see a clinician.
                  </p>
                </div>
              </div>
            </div>

            <div className="p-4" style={{ backgroundColor: '#e7f3ff', borderRadius: '8px', borderLeft: '4px solid #0066cc' }}>
              <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                <strong>Important:</strong> Patients cannot proceed to see a doctor until registration and insurance verification are completed at the Records Unit.
              </p>
            </div>
          </div>
        </ScrollSection>

        {/* Section 2: Types of Insurance Accepted */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Types of Insurance Accepted
            </h2>

            <div className="row g-4 mb-4">
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0', height: '100%' }}>
                  <h3 className="mb-3" style={{ fontSize: '1.3rem', fontWeight: '600', color: '#000' }}>
                    National Health Insurance Scheme (NHIS)
                  </h3>
                  <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
                    <li>NHIS is widely accepted at Tema General Hospital.</li>
                    <li>Covers many outpatient, inpatient, maternity, and emergency services.</li>
                    <li>Some medications, investigations, or procedures may not be covered under NHIS.</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="p-4" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0', height: '100%' }}>
                  <h3 className="mb-3" style={{ fontSize: '1.3rem', fontWeight: '600', color: '#000' }}>
                    Private Health Insurance
                  </h3>
                  <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: 0 }}>
                    <li>Selected private health insurance providers are accepted.</li>
                    <li>Coverage depends on the patient's insurance plan and existing agreements.</li>
                    <li>Some services may require pre-authorization before they can be provided.</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
              <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                Patients are advised to confirm coverage details with the Records or Accounts Office during registration.
              </p>
            </div>
          </div>
        </ScrollSection>

        {/* Section 3: Options for Uninsured Patients */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Options for Uninsured Patients
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              Patients without active insurance are still able to receive care at Tema General Hospital.
            </p>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              Available Options
            </h3>

            <div className="row g-4">
              <div className="col-md-4">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <div className="mb-3" style={{ fontSize: '2.5rem', color: '#0066cc' }}>
                    <i className="bi bi-cash-coin"></i>
                  </div>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    Out-of-Pocket Payment
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Patients may pay directly for services at the Accounts Office before registration is completed.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <div className="mb-3" style={{ fontSize: '2.5rem', color: '#0066cc' }}>
                    <i className="bi bi-heart-pulse"></i>
                  </div>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    Emergency Care
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Emergency cases are treated immediately, regardless of insurance status.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', height: '100%' }}>
                  <div className="mb-3" style={{ fontSize: '2.5rem', color: '#0066cc' }}>
                    <i className="bi bi-card-checklist"></i>
                  </div>
                  <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    NHIS Enrollment Guidance
                  </h4>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Patients may be advised on how to register or renew their NHIS for future visits.
                  </p>
                </div>
              </div>
            </div>

            <div className="p-4 mt-4" style={{ backgroundColor: '#e7f3ff', borderRadius: '8px' }}>
              <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                Patients are strongly encouraged to maintain a valid NHIS card to reduce healthcare costs and delays.
              </p>
            </div>
          </div>
        </ScrollSection>

        {/* Section 4: Insurer-Denied or Uncovered Services */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Insurer-Denied or Uncovered Services
            </h2>
            <p style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: '2rem' }}>
              Even after insurance validation, some services may not be approved by the insurer.
            </p>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              Common Reasons for Denial
            </h3>
            <ul style={{ fontSize: '1rem', color: '#333', lineHeight: '1.8', marginBottom: '2rem' }}>
              <li>Expired or inactive insurance</li>
              <li>Services not covered under the insurance benefit package</li>
              <li>Missing pre-authorization</li>
              <li>Exceeded insurance limits</li>
            </ul>

            <h3 className="mb-3" style={{ fontSize: '1.5rem', fontWeight: '600', color: '#000' }}>
              What Happens Next
            </h3>
            <div className="row g-4">
              <div className="col-md-4">
                <div className="p-4 h-100" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                  <h5 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    Patient Is Informed
                  </h5>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    The patient is informed by the Records, Accounts, or clinical staff.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="p-4 h-100" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                  <h5 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    Payment for Uncovered Services
                  </h5>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Patients may be required to pay out-of-pocket for services not approved.
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="p-4 h-100" style={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e0e0e0' }}>
                  <h5 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000', marginBottom: '1rem' }}>
                    Follow-Up With Insurer
                  </h5>
                  <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                    Patients may contact their insurance provider for clarification or appeals. Hospital staff are available to assist patients with explanations and guidance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </ScrollSection>

        {/* Section 5: Frequently Asked Questions */}
        <ScrollSection>
          <div>
            <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Frequently Asked Questions (FAQs)
            </h2>

            <div className="accordion" id="insuranceFAQAccordion">
              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '1rem' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq1"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    Who checks my insurance at Tema General Hospital?
                  </button>
                </h2>
                <div id="faq1" className="accordion-collapse collapse show" data-bs-parent="#insuranceFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    Insurance is checked and validated by the Records (Health Information) Unit during registration.
                  </div>
                </div>
              </div>

              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '1rem' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq2"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    Can I see a doctor before my insurance is checked?
                  </button>
                </h2>
                <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#insuranceFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    No. Patients must complete registration and insurance verification before seeing a doctor, except in emergencies.
                  </div>
                </div>
              </div>

              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '1rem' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq3"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    What if my NHIS card is expired?
                  </button>
                </h2>
                <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#insuranceFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    You will be required to pay out-of-pocket or renew your NHIS before registration can be completed.
                  </div>
                </div>
              </div>

              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', marginBottom: '1rem' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq4"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    Can I receive emergency care without insurance?
                  </button>
                </h2>
                <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#insuranceFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    Yes. Emergency cases are attended to immediately.
                  </div>
                </div>
              </div>

              <div className="accordion-item" style={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq5"
                    style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000' }}
                  >
                    Where can I get help with insurance issues?
                  </button>
                </h2>
                <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#insuranceFAQAccordion">
                  <div className="accordion-body" style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6' }}>
                    Visit the Records Unit, Accounts Office, or ask at the OPD front desk.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ScrollSection>
      </div>
    </>
  );
}

export default InsuranceSelfPay;
